export default __webpack_public_path__ + "static/media/ldo_ADJ_EN_Cff.f4c98225.svg";